@use "sass:color";
@use "foundation/colors";
@use "foundation/responsive";
@use "diy_base.module";

.warning-container {
  margin-top: 4px;
  width: diy_base.$box-width;

  @include responsive.phone {
    width: diy_base.$box-width-phone;
  }
}

.warning {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 0;
  border-radius: diy_base.$border-radius;
  background-color: #E8E8E8;
  color: #4A4A4A;
  border: none;
  width: 100%;
  box-sizing: border-box;

  &:last-child {
    margin-bottom: 0;
  }
}

.warning-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.warning-svg {
  width: 100%;
  height: 100%;
  display: block;
}

.warning-text {
  flex: 1;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: colors.$neutrals-darker-grey;

  @include responsive.phone {
    font-size: 14px;
    line-height: 20px;
  }
}
